import React, { useState } from 'react';
import {
  Button,
  useTranslate,
  useRefresh,
  Notification,
} from 'react-admin';
import SleuthForm from './form';
import {
  Edit as IconContentEdit,
  Close as CloseIcon,
} from '@material-ui/icons';
import { Dialog, DialogTitle, Grid, IconButton } from '@material-ui/core';
import { linkButton } from 'styles';

const resource = 'eventSuperSleuth';

const SleuthQuickEditButton = (props) => {
  const { record } = props;

  const [showDialog, setShowDialog] = useState(false);
  const translate = useTranslate();
  const refresh = useRefresh();
  const buttonClasses = linkButton();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  return (
    <>
      <Button
        className={buttonClasses.root}
        onClick={handleClick}
        label="ra.action.edit"
      >
        <IconContentEdit />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={`Edit ${resource}`}
      >
        <DialogTitle>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            {translate(`resources.${resource}.titles.edit`)}
            <IconButton aria-label="close" onClick={handleCloseClick}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </DialogTitle>
        <SleuthForm
          record={record}
          resource={resource}
          onSuccess={(data) => {
            setShowDialog(false);
            refresh();
          }}
        />
        <Notification />
      </Dialog>
    </>
  );
};

export default SleuthQuickEditButton;
